import React, { type MouseEventHandler } from "react"
import styled from "styled-components"
import { Icon } from "@autouncle/ui"
import { ChevronDown, ChevronUp } from "@autouncle/icons"

type CategoryButtonProps = {
  expanded: boolean
  icon: React.FunctionComponent
  label: React.ReactNode
  onClick: MouseEventHandler
  selected: boolean
  sidebarCollapsed: boolean
}

const StyledButton = styled.button`
  display: flex;
  align-items: center;
  align-self: stretch;
  text-align: left;
  height: var(--tappable-size-lg);
  padding: 0px var(--spacing-md);
  gap: var(--spacing-sm);
  cursor: pointer;
`

// Changes the color of the icon based on whether the category is selected or not
const IconColor = styled.div<{ $selected?: boolean }>`
  display: contents;
  color: ${(props) =>
    props.$selected ? "white" : "var(--text-color-disabled)"};
`

const Label = styled.div`
  flex: 1;
`

const CategoryButton = ({
  label,
  expanded,
  icon: IconComponent,
  onClick,
  selected,
  sidebarCollapsed,
}: CategoryButtonProps) => {
  return (
    <StyledButton onClick={onClick}>
      <IconColor $selected={selected}>
        <Icon size="lg" svg={<IconComponent />} />
      </IconColor>
      {!sidebarCollapsed && (
        <>
          <Label>{label}</Label>
          <Icon size="lg" svg={expanded ? <ChevronUp /> : <ChevronDown />} />
        </>
      )}
    </StyledButton>
  )
}

export default CategoryButton
